import { combineReducers } from "redux";
import userInfo from "./user";
import modals from "./modals";
import loading from "./loading";
export default combineReducers({
  userInfo,
  modals,
  loading
});
